var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38756 3.51256C6.05937 3.84075 5.875 4.28587 5.875 4.75C5.875 5.21413 6.05937 5.65925 6.38756 5.98744C6.71575 6.31563 7.16087 6.5 7.625 6.5C8.08913 6.5 8.53425 6.31563 8.86244 5.98744C9.19062 5.65925 9.375 5.21413 9.375 4.75C9.375 4.28587 9.19062 3.84075 8.86244 3.51256C8.53425 3.18438 8.08913 3 7.625 3C7.16087 3 6.71575 3.18438 6.38756 3.51256Z",
    fill: "#616876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 7.375H6.3125L5 10.875H6.3125V13.5H8.9375V10.875H10.25L8.9375 7.375Z",
    fill: "#616876"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/Child.97f5f658fccd4a67c810b695230d9323.svg";
export { ForwardRef as ReactComponent };